import AboutUs from "./components.tsx";

export default AboutUs;